<template lang="pug">
  .input_container
    flat-pickr(v-mask="'##.##.####'" title="При ручном вводе данные нужно вводить только через точку" type="text" :config="format || defaultConfig" :placeholder="placeholder || 'дд.мм.гггг'" v-model="value" @input="returnValue")
    button.open(data-toggle :tabindex="-1")
      v-icon(name="calendar-alt")
    button.delete(:tabindex="-1" data-clear ) ✖
</template>
<script>
import flatPickr from 'vue-flatpickr-component'
import { Russian } from 'flatpickr/dist/l10n/ru.js'
import 'flatpickr/dist/flatpickr.css'
import { mask } from 'vue-the-mask'
import Icon from 'vue-awesome/components/Icon'

export default {
  props: ['value', 'format', 'placeholder'],
  components: {
    flatPickr,
    'v-icon': Icon
  },
  directives: { mask },
  computed: {
    defaultConfig () {
      return {
        maxDate: new Date(),
        locale: Russian,
        wrap: true,
        allowInput: true,
        dateFormat: 'd.m.Y'
      }
    }
  },
  // data() {
  //   return {
  //     value: null
  //   };
  // },
  methods: {
    returnValue () {
      this.$emit('input', this.value)
    }
  }
}
</script>
<style lang="sass" scoped>
.input_container
  display: grid
  grid-template-columns: auto 70px 50px
input
  border-radius: 4px 0px 0px 4px
  height: 30px
  border: 1px solid #ccc
  font-size: 15px
  color: #212121
  padding-left: 7px
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s
  outline: none
input:focus
  border-radius: 4px 4px 4px 4px
  border-color: rgba(26, 163, 255, 0.8)
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(0, 153, 255, 0.6)
button
  border: 1px solid #ccc
  border-left: none
  background: white
  display: grid
  align-content: center
  justify-content: center
  cursor: pointer
  outline: none
.open
  display: flex
  justify-content: center
  align-items: center
.delete
  border-left: none
  border-radius: 0 4px 4px 0
.delete:hover
  transition: all, .3s
  color: #e2211d
  font-weight: bold
</style>
